import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';

import { StorageUploadFileDto } from '../dto';
import { StorageUploadLink } from '../model';
import { GenericApiOption, GenericApiService } from '@core/generic-api/data-access';
import { AppConfigService } from '@core/app-config/data-access';
import { Helper } from '@portal/util';

@Injectable()
export abstract class GenericStorageApiService {
  protected readonly api = inject(GenericApiService);
  protected readonly appConfigService = inject(AppConfigService);
  protected readonly http = inject(HttpClient);
  abstract UPLOAD_LINK: string;
  abstract PUBLIC_LINK: string;

  abstract getUploadLink(dto: any, requestOption?: GenericApiOption): Observable<StorageUploadLink>;

  abstract getPublicLink(dto: any, requestOption?: GenericApiOption): Observable<string>;

  uploadFile(dto: StorageUploadFileDto): Observable<unknown> {
    const config = this.appConfigService.getConfig();

    if (config.storageDrive === 'azure') {
      return this.uploadAzureFile(dto);
    }

    if (config.storageDrive === 's3') {
      return this.uploadS3File(dto);
    }

    return throwError(() => new Error('Invalid Storage Drive'));
  }

  private uploadS3File(dto: StorageUploadFileDto): Observable<unknown> {
    const formData = new FormData();

    if (dto.isPublic) dto.fields.acl = 'public-read';
    Object.keys(Helper.removeEmpty(dto.fields)).forEach(key => formData.append(key, dto.fields[key]));
    formData.append('file', dto.file);

    return this.http.post(dto.url, formData);
  }

  private uploadAzureFile(dto: StorageUploadFileDto): Observable<unknown> {
    const headers = new HttpHeaders({
      'x-ms-blob-type': dto.fields['x-ms-blob-type'],
      'Content-Type': dto.fields['Content-Type'],
    });
    return this.http.put(dto.url, dto.file, { headers });
  }
}
